import request from '@/utils/request'
import Vue from 'vue'

export function addLog(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/clesun/api/v1.0/CApiLog/add',
        data
    })
}